import { useState } from 'react'
import { CloseRounded } from '@mui/icons-material'
import { Box, Button, IconButton, Modal, Stack, Typography } from '@mui/material'
import Step1 from '../../assets/pt-interactive/step1_de.png'
import Step2 from '../../assets/pt-interactive/step2_de.png'
import Step3 from '../../assets/pt-interactive/step3_de.png'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 800,
  bgcolor: 'background.paper',
  borderRadius: 2,
  boxShadow: 24,
  p: 4,
}

const PTModalDE = ({ isOpen, onClose }: { isOpen: boolean; onClose: () => void }) => {
  const [curPage, setCurPage] = useState(1)

  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={{ zIndex: 2000 }}
    >
      <Box sx={style}>
        <IconButton sx={{ position: 'absolute', right: 10, top: 10 }} onClick={onClose}>
          <CloseRounded />
        </IconButton>
        <Typography id="modal-modal-title" variant="h6" component="h2" color="primary">
          Einführung in das Auskunftssystem
        </Typography>
        {curPage === 1 && (
          <>
            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
              Mit dem Auskunftssystem können Sie einfach der Auskunftspflicht der
              EU-Entgelttransparenzrichtlinie (2023/970) entsprechen. Sie erhalten für jede gleiche
              oder gleichwertige Tätigkeit einen Überblick über die Entgelte der beschäftigten
              Frauen und Männer im Unternehmen. Dieses System kann auch zur Auskunft von Entgelten
              für zukünftige Beschäftigte genutzt werden.
            </Typography>
            <Typography sx={{ mt: 2 }}>
              Alle Ergebnisse werden als PDF oder CSV zur Verfügung gestellt.
            </Typography>
            <Typography color="primary" sx={{ mt: 2, fontWeight: 'bold' }}>
              So verwenden Sie das System:
            </Typography>
            <Typography sx={{ mt: 2, fontWeight: 'bold' }}>Schritt 1</Typography>
            <Typography>
              Wählen Sie die relevante Tätigkeit in ihrem Unternehmen aus und erfassen Sie das
              derzeitige Bruttojahresgrundentgelt als Vollzeitäquivalent des Beschäftigten bzw. der
              Beschäftigten.
            </Typography>
            <Typography>
              Es ist auch möglich das geplante Entgelt einer zukünftig beschäftigten Person zu
              erfassen.
            </Typography>
            <Stack
              sx={{
                width: '100%',
                height: 250,
                alignItems: 'center',
                justifyContent: 'center',
                mt: 2,
              }}
            >
              <img src={Step1} height={250} alt="step" />
            </Stack>
          </>
        )}
        {curPage === 2 && (
          <>
            <Typography sx={{ mt: 2, fontWeight: 'bold' }}>Schritt 2</Typography>
            <Typography>
              Nun werden die durchschnittlichen Entgelte nach Geschlecht in der entsprechenden
              Gruppe gleicher oder gleichwertiger Arbeit angezeigt.
            </Typography>
            <Typography sx={{ mt: 2 }}>
              Die Grafik zeigt Ihnen wie Ihr Entgelt im Vergleich zu den anderen Beschäftigten der
              gleichen Gruppe ausfällt.
            </Typography>
            <Stack
              sx={{
                width: '100%',
                height: 425,
                alignItems: 'center',
                justifyContent: 'center',
                mt: 2,
              }}
            >
              <img src={Step2} height={425} alt="step" />
            </Stack>
          </>
        )}
        {curPage === 3 && (
          <>
            <Typography sx={{ mt: 2, fontWeight: 'bold' }}>Schritt 3</Typography>
            <Typography>
              Wählen Sie die Informationen aus, die sie entweder als PDF oder als CSV exportieren
              möchten.
            </Typography>
            <Typography sx={{ mt: 2 }}>Diagramme werden nur in PDFs exportiert.</Typography>
            <Stack
              sx={{
                width: '100%',
                height: 400,
                alignItems: 'center',
                justifyContent: 'center',
                mt: 2,
              }}
            >
              <img src={Step3} height={400} alt="step" />
            </Stack>
          </>
        )}
        <Stack direction="row" justifyContent="flex-end" mt={4} alignItems="center">
          {curPage > 1 && <Button onClick={() => setCurPage(curPage - 1)}>Zurück</Button>}
          {curPage < 3 && (
            <Button variant="contained" sx={{ ml: 2 }} onClick={() => setCurPage(curPage + 1)}>
              Weiter
            </Button>
          )}
          {curPage === 3 && (
            <Button variant="contained" sx={{ ml: 2 }} onClick={onClose}>
              Starten
            </Button>
          )}
        </Stack>
      </Box>
    </Modal>
  )
}

export default PTModalDE
